module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-reservation d-flex"
  }, [_c('div', {
    staticClass: "main-column p-4"
  }, [_c('agent', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('basic'), _vm._v(" "), _c('price-counters', {
    on: {
      "updatePrices": _vm.updatePrices
    }
  }), _vm._v(" "), _c('customer', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('transport', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('extras', {
    attrs: {
      "editable": true
    },
    on: {
      "updateExtras": _vm.updateExtras
    }
  }), _vm._v(" "), _c('notes', {
    on: {
      "updateNotes": _vm.updateNotes
    }
  })], 1), _vm._v(" "), _c('summary-panel')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigator"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("New Reservation")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-116caba6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116caba6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Form.vue
// module id = 2826
// module chunks = 0